import { AnnouncementBar } from "@/components/AnnouncementBar";
import { SiteHeader } from "@/components/SiteHeader";
import { ProductHero } from "@/components/ProductHero";
import { ProductShowcase } from "@/components/ProductShowcase";
import { Benefits } from "@/components/Benefits";
import { Ingredients } from "@/components/Ingredients";
import { HowToUse } from "@/components/HowToUse";
import { SpecsTable } from "@/components/SpecsTable";
import { Reviews } from "@/components/Reviews";
import { SiteFooter } from "@/components/SiteFooter";
import { CartDrawer } from "@/components/CartDrawer";
import { CheckoutDialog } from "@/components/CheckoutDialog";
import { OrderSuccess } from "@/components/OrderSuccess";
import { StickyBuyBar } from "@/components/StickyBuyBar";
import { LiveUrgency } from "@/components/LiveUrgency";
import { AgeGate } from "@/components/AgeGate";

export default function Home() {
  return (
    <div className="min-h-screen pb-20 lg:pb-0">
      <AgeGate />
      <AnnouncementBar />
      <SiteHeader />
      <main>
        <ProductHero />
        <ProductShowcase />
        <Benefits />
        <Ingredients />
        <HowToUse />
        <SpecsTable />
        <Reviews />
      </main>
      <SiteFooter />

      <CartDrawer />
      <CheckoutDialog />
      <OrderSuccess />
      <StickyBuyBar />
      <LiveUrgency />
    </div>
  );
}
